import React from "react";
import TableBody from "../../components/core/table/components/table-body";
import TableHead from "../../components/core/table/components/table-head";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { NavLink } from "react-router-dom";
import { classNames } from "primereact/utils";
import { Divider } from "primereact/divider";

export default function StayTimeTable({
	className,
	headers = [
		{
			header_name: "Column 1",
			header_key: "column1",
		},
		{
			header_name: "Column 2",
			header_key: "column2",
		},
	],
	items = [
		{
			column1: "Column 2",
			column2: "Column 2",
		},
	],
	isNative = false,
	children,
	linkName,
	linkBody,
	fieldId,
	actionColumn,
	bottomAction,
	dt,
	multiItemField,
}) {
	const withLinkTemplate = (rowData) => {
		if (Array.isArray(fieldId)) {
			return (
				<a
					className={"text-component-blueTextColor"}
					href={`${process.env.REACT_APP_BASE_ENVIRONMENT}${linkBody}/${rowData[fieldId[0]]
						}/${rowData[fieldId[1]]}`}
					target="_blank"
				>
					{rowData[linkName]}
				</a>
			);
		} else {
			return (
				<a
					className={"text-component-blueTextColor"}
					href={`${process.env.REACT_APP_BASE_ENVIRONMENT}${linkBody}/${rowData[fieldId]}`}
					target="_blank"
				>
					{rowData[linkName]}
				</a>
			);
		}
	};

	const multiItemTemplate = (rowData) => {
		return (
			<div>
				{Object.values(rowData[multiItemField]).map((element) => {
					return (
						<div className="border-b-2 border-black-500">
							<p>{element}</p>
						</div>
					);
				})}
			</div>
		);
	};

	// Assuming you have another item you want to add to the table
	const additionalItem = {
		column1: "Total",
		column2: "Additional Column 2",
	};

	const updatedItems = [...items, additionalItem];

	return (
		<div>
			{updatedItems.length === 0 ? (
				<p>No results found.</p>
			) : (
				<DataTable
					paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
					currentPageReportTemplate="{first} to {last} of {totalRecords}"
					value={updatedItems}
					rows={10}
					sortMode="multiple"
					sortField="name"
					sortOrder={1}
					stripedRows
					ref={dt}
					showGridlines
					tableStyle={{
						minWidth: "50rem",
						borderWidth: 2,
						borderColor: "#E6E6E6",
					}}
					removableSort
				>
					{headers.map((data, key) => {
						if (linkBody && linkName === data.header_key) {
							return (
								<Column
									field={data.header_key}
									sortable
									header={data.header_name}
									body={withLinkTemplate}
									headerStyle={{ width: "3rem", backgroundColor: "#FECD08" }}
								></Column>
							);
						}
						if (data.header_key === multiItemField) {
							return (
								<Column
									sortable
									header={data.header_name}
									body={multiItemTemplate}
									headerStyle={{ width: "3rem", backgroundColor: "#FECD08" }}
								></Column>
							);
						}
						return (
							<Column
								field={data.header_key}
								sortable
								header={data.header_name}
								headerStyle={{ width: "3rem", backgroundColor: "#FECD08" }}
							></Column>
						);
					})}
				</DataTable>
			)}
		</div>
	);
}
